import utils from '../utils'
import apiClient from './AxiosHttp'

const getVendorStore = () => {
    return apiClient.get('/stores/vendor/fetch/')
}

const getStoreStats = () => {
    return apiClient.get('/stores/stats/')
}

const createStore = (details) => {
    return apiClient.post(
        '/stores/create/',
        details,
        { headers: utils.multipartHeader }
    )
}

const updateStore = (details) => {
    return apiClient.patch(
        `/stores/vendor/actions/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const deleteStore = (id) => {
    return apiClient.delete(`/stores/vendor/actions/${id}/`)
}

const getProducts = (params) => {
    return apiClient.get(`/stores/products/${params}`)
}

const createStoreProduct = (detail) => {
    return apiClient.post(
        `/stores/products/`,
        detail,
        { headers: utils.multipartHeader }
    )
}

const updateStoreProduct = (id, details) => {
    return apiClient.patch(
        `/stores/product/${id}/`,
        details,
        { headers: utils.multipartHeader }
    )
}

const deleteStoreProduct = (id) => {
    return apiClient.delete(`/stores/product/${id}/`)
}

const getStores = (params) => {
    return apiClient.get(`/stores/list/${params}`)
}

const getPurchases = (params) => {
    return apiClient.get(`/stores/payments/${params}`)
}

const getRefunds = (params) => {
    return apiClient.get(`/stores/refunds/${params}`)
}

const updateRefund = (id, details) => {
    return apiClient.patch(`/stores/refunds/${id}/`, details)
}

const productStats = () => {
    return apiClient.get(`/stores/metrics/products/`)
}

const paymentsStats = () => {
    return apiClient.get(`/stores/metrics/payments/`)
}

const refundsStats = () => {
    return apiClient.get(`/stores/metrics/refunds/`)
}

const paymentCharts = (params) => {
    return apiClient.get(`/stores/metrics/payments/charts/${params}`)
}

const vendorServices = {
    getVendorStore,
    createStore,
    deleteStore,
    getProducts,
    updateStore,
    getStores,
    createStoreProduct,
    updateStoreProduct,
    deleteStoreProduct,
    getStoreStats,
    getPurchases,
    getRefunds,
    updateRefund,
    productStats,
    paymentsStats,
    refundsStats,
    paymentCharts,
}

export default vendorServices